import { Calculator, ArrowRight, Zap, BatteryCharging, Sun } from "lucide-react";
import { useNavigate } from "react-router-dom";

export const CalculatorCTA = () => {
  const navigate = useNavigate();

  return (
    <section id="calcolatore" className="py-16 sm:py-24 relative overflow-hidden" data-testid="calculator-cta-section">
      <div className="absolute inset-0 bg-gradient-to-br from-slate-900 via-slate-800 to-emerald-900" />
      <div className="absolute inset-0 grain opacity-30" />

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
        <div className="flex flex-col lg:flex-row items-center gap-10 lg:gap-16">
          {/* Left - Text */}
          <div className="flex-1 text-center lg:text-left">
            <span className="inline-flex items-center gap-1.5 bg-emerald-500/20 text-emerald-300 text-xs font-semibold px-3 py-1.5 rounded-full border border-emerald-500/30 mb-5">
              <Calculator className="w-3 h-3" />
              Calcolatore Gratuito
            </span>
            <h2
              className="text-3xl sm:text-4xl font-bold text-white tracking-tight mb-4"
              style={{ fontFamily: "Outfit, sans-serif" }}
              data-testid="calculator-cta-title"
            >
              Scopri il tuo impianto<br />ideale in 30 secondi
            </h2>
            <p className="text-base text-slate-300 max-w-lg mb-8 leading-relaxed">
              Il nostro calcolatore ti mostra in tempo reale il tipo di impianto, la batteria consigliata
              e quanto puoi risparmiare ogni anno sulla bolletta.
            </p>
            <button
              onClick={() => navigate("/calcolatore")}
              className="inline-flex items-center gap-2 bg-emerald-500 hover:bg-emerald-600 text-white font-bold rounded-full px-8 py-4 text-base btn-scale shadow-xl shadow-emerald-500/30"
              data-testid="calculator-cta-button"
            >
              <Calculator className="w-5 h-5" />
              Calcola il Tuo Risparmio
              <ArrowRight className="w-5 h-5" />
            </button>
          </div>

          {/* Right - Preview cards */}
          <div className="flex-1 w-full max-w-md">
            <div className="space-y-4">
              <div className="bg-white/10 backdrop-blur-sm border border-white/10 rounded-2xl p-5 flex items-center gap-4">
                <div className="w-12 h-12 rounded-xl bg-emerald-500/20 flex items-center justify-center flex-shrink-0">
                  <Sun className="w-6 h-6 text-emerald-400" strokeWidth={1.5} />
                </div>
                <div>
                  <div className="text-white font-semibold text-sm">Impianto Personalizzato</div>
                  <div className="text-slate-400 text-xs">Pannelli, potenza e produzione calcolati sui tuoi consumi</div>
                </div>
              </div>
              <div className="bg-white/10 backdrop-blur-sm border border-white/10 rounded-2xl p-5 flex items-center gap-4">
                <div className="w-12 h-12 rounded-xl bg-blue-500/20 flex items-center justify-center flex-shrink-0">
                  <BatteryCharging className="w-6 h-6 text-blue-400" strokeWidth={1.5} />
                </div>
                <div>
                  <div className="text-white font-semibold text-sm">Batteria Consigliata</div>
                  <div className="text-slate-400 text-xs">Tipo, capacità e tecnologia ottimali per massimizzare il risparmio</div>
                </div>
              </div>
              <div className="bg-white/10 backdrop-blur-sm border border-white/10 rounded-2xl p-5 flex items-center gap-4">
                <div className="w-12 h-12 rounded-xl bg-amber-500/20 flex items-center justify-center flex-shrink-0">
                  <Zap className="w-6 h-6 text-amber-400" strokeWidth={1.5} />
                </div>
                <div>
                  <div className="text-white font-semibold text-sm">Risparmio in Tempo Reale</div>
                  <div className="text-slate-400 text-xs">Confronto con e senza batteria, proiezione a 25 anni</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
